module.exports = __webpack_public_path__ + "img/033-storm-11.8706e0ad.svg";